import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputField from "components/fields/InputField";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { login } from "../../store/reducers/userSlice";
import { API_POST__FORGET_PASSWORD } from "api/auth";
import { toast } from "react-toastify";

const ForgotPasswordSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email").required("Email is required"),
});

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    console.log("values", values);
    try {
      const userData = await API_POST__FORGET_PASSWORD(values);
      toast?.success(userData?.message)
      navigate("/auth/verify");
      // localStorage.setItem("userData", JSON.stringify(userData?.data));ss
      // dispatch(login(userData));
    } catch (error) {
      console.error("Error:", error);
      toast.error(error?.response?.data?.message)

      setFieldError("email", "Invalid email or password");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
      <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
        <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
          Forgot Password
        </h4>
        <p className="mb-9 ml-1 text-base text-gray-600">
          Enter your email to receive a password reset link.
        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={ForgotPasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ isSubmitting }) => (
            <Form>
              <Field
                className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                variant="auth"
                extra="mb-3"
                label="Email*"
                placeholder="mail@simple.com"
                name="email"
                type="text"
              />
              <ErrorMessage
                name="email"
                component="div"
                className="text-red-500"
              />

              <button
                type="submit"
                disabled={isSubmitting}
                className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
              >
                {isSubmitting ? "Sending..." : "Send Reset Link"}
              </button>
            </Form>
          )}
        </Formik>

        <div className="mt-4">
          <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
            Remember your password?{" "}
          </span>
          <Link
            to="/auth/sign-in"
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
